// @flow

import { type IncomingPayment } from './types';

export function getDestinyBank(incomingPayment: IncomingPayment): string {
  const speiBankInfo = incomingPayment['spei_bank_info'];
  if (!speiBankInfo || speiBankInfo != 'spei-arcus'){
    return 'Sistema de Transferencias y Pagos (STP)';
  }
  return 'Arcus';
}
